import { Box } from "@mui/system";
import { useSelector } from "react-redux";
import GraphSkeletonForTrendsMob from "../../../helpers/components/GraphSkeletonForTrendsMob";
import FTDOverTimeChartWrap from "./FTDContent/FTDOverTime/FTDOverTimeChartWrap";
import GapBetweenFTDQFTDChartWrap from "./FTDContent/GapBetweenFTDQFTD/GapBetweenFTDQFTDChartWrap";
import ProfitAndFTDChartWrap from "./FTDContent/ProfitAndFTD/ProfitAndFTDChartWrap";

const FTD = () => {
  const { loadingTrendsMobData } = useSelector((state: any) => state.trends);
  return (
    <>
      <Box sx={{ px: 2 }}>
        {loadingTrendsMobData ? (
          Array.from({ length: 2 }).map((_, index) => (
            <GraphSkeletonForTrendsMob key={index} />
          ))
        ) : (
          <>
            <FTDOverTimeChartWrap />
            <GapBetweenFTDQFTDChartWrap />
            <ProfitAndFTDChartWrap />
          </>
        )}
      </Box>
    </>
  );
};

export default FTD;
